import { analyticsRuntime, runtimeEnv } from '@/config/featureFlags';

const shouldLogAnalyticsDebug = () => runtimeEnv.isDevelopment || analyticsRuntime.debugEnabled;

function isGtagAvailable() {
  return typeof window !== 'undefined' && typeof window.gtag === 'function';
}

function runAnalyticsTask(task) {
  if (typeof window === 'undefined') {
    return;
  }

  const execute = () => {
    try {
      task();
    } catch (error) {
      console.error('[Analytics] Transport error:', error);
    }
  };

  if (typeof window.requestIdleCallback === 'function') {
    window.requestIdleCallback(execute, { timeout: 1200 });
    return;
  }

  window.setTimeout(execute, 0);
}

export const webGtagTransport = Object.freeze({
  name: 'web_gtag',

  isAvailable() {
    return isGtagAvailable();
  },

  sendEvent(eventName, payload) {
    if (!isGtagAvailable()) {
      console.warn('[Analytics] Google Analytics not initialized');
      return;
    }

    runAnalyticsTask(() => {
      window.gtag('event', eventName, payload);
    });

    if (shouldLogAnalyticsDebug()) {
      console.log(`[Analytics] Event tracked: ${eventName}`, payload);
    }
  },

  setUserId(measurementId, userId) {
    if (!isGtagAvailable() || !userId || !measurementId) {
      return;
    }

    runAnalyticsTask(() => {
      window.gtag('config', measurementId, {
        user_id: userId
      });
    });

    if (shouldLogAnalyticsDebug()) {
      console.log(`[Analytics] User ID set: ${userId}`);
    }
  }
});
